module.exports = __webpack_public_path__ + "static/Chicory5-39fd7313d919e71ca63a39948d5e3486.webp";